function getGiftHandlesArray() {
    return window.tlAdvancedFreeGift.rules.flatMap(rule => 
        rule.auto_remove_gift ? rule.listChilds.map(child => child.handle) : []
    );
}

async function getCartData() {
    const response = await fetch('/cart.js');
    const responseData = await response.json();
    return responseData;
}

const newUpdateCartData = async () => {
    try {
        const cartDataReq = await fetch(window.Shopify.routes.root + 'cart.js')
        const response = await cartDataReq.json();
        const cartDataRes = {
            ...response,
            items: response.items.filter(item => !(item.properties['_salepify-advanced-fg'] && Array.isArray(item.discounts) && item.discounts.length === 0))
        }

        window.tlAdvancedFreeGift.cartId = cartDataRes.token;
        const itemsInCart = new Map();
        const ruleIdMapGiftQtyInCart = new Map();
        const ruleIdMapGiftAddedByApp = new Map();
        if(cartDataRes.items.length){
            let ratio = 1;
            for (let i = 0; i < cartDataRes.items.length; i++) {
                const item = cartDataRes.items[i];
                if(!isNaN(item.price/item.presentment_price)){
                    ratio = item.price / item.presentment_price;
                    break;
                }
            }
            
            for (let i = 0; i < cartDataRes.items.length; i++) {
                const item = cartDataRes.items[i];
                    
                const itemKey = item.key;
                const itemId = String(item.id);
                const productId = String(item.product_id);

                const itemData = {
                    id: itemId,
                    price: item.final_price / ratio,
                    quantity: item.quantity ,
                    productId: productId,
                    collectionIds: window.tlAdvancedFreeGift.productIdMapCollection.get(productId)
                }

                if(!itemData.collectionIds){
                    await window.tlAdvancedFreeGift.getVariantData(itemId);
                    itemData.collectionIds = window.tlAdvancedFreeGift.productIdMapCollection.get(productId);
                }

                let currentAppliedRuleId = null;
                item.discounts.map(discount => {
                    if (window.tlAdvancedFreeGift.discountCodeMapRuleId.get(discount.title)) {
                        currentAppliedRuleId = window.tlAdvancedFreeGift.discountCodeMapRuleId.get(discount.title)
                    }
                })

                let ruleInProperty = null;
                // If has property => is gift added from app 
                if(item.properties[window.tlAdvancedFreeGift.PROPERTY]){
                    const ruleId = item.properties[window.tlAdvancedFreeGift.PROPERTY];
                    ruleInProperty = window.tlAdvancedFreeGift.ruleIdMapData.get(ruleId);
                    if(ruleInProperty){
                        // Save list gift added from app by RuleId
                        const currentGiftInCart = ruleIdMapGiftAddedByApp.get(ruleId) ?
                            ruleIdMapGiftAddedByApp.get(ruleId) : [];

                        ruleIdMapGiftAddedByApp.set(ruleId, [...currentGiftInCart, {
                            key: itemKey,
                            quantity: item.quantity
                        }])
                    }
                }

                // Case: Item is applied discount => gift
                if(currentAppliedRuleId){
                    const currentGiftQtyInCart = ruleIdMapGiftQtyInCart.get(currentAppliedRuleId) ?
                        ruleIdMapGiftQtyInCart.get(currentAppliedRuleId) : 0;

                    ruleIdMapGiftQtyInCart.set(currentAppliedRuleId, currentGiftQtyInCart + item.quantity );
                }else if(ruleInProperty){
                    // Case: Item has original price equals 0 and has property of app => is Gift
                    const currentGiftQtyInCart = ruleIdMapGiftQtyInCart.get(ruleInProperty.id) ?
                        ruleIdMapGiftQtyInCart.get(ruleInProperty.id) : 0;

                    ruleIdMapGiftQtyInCart.set(ruleInProperty.id, currentGiftQtyInCart + item.quantity );
                }else {
                    itemsInCart.set(itemKey, itemData);
                }
            }
        }

        window.tlAdvancedFreeGift.itemsInCart = new Map(itemsInCart);
        window.tlAdvancedFreeGift.ruleIdMapGiftQtyInCart = new Map(ruleIdMapGiftQtyInCart);
        window.tlAdvancedFreeGift.ruleIdMapGiftAddedByApp = new Map(ruleIdMapGiftAddedByApp);
        //Clear temp cart
        window.tlAdvancedFreeGift.itemsInTempCart.clear();
        window.tlAdvancedFreeGift.giftsInTempCart.clear();

        if(window.tlAdvancedFreeGift.firstLoading){
            await window.tlAdvancedFreeGift.render();
            window.tlAdvancedFreeGift.firstLoading = false;
        }else{
            await window.tlAdvancedFreeGift.reRender();
        }
    } catch (error) {
        console.log("Error when updateCartData - Salepify Advanced Gift: ", error)
    }
}
const newRender = async () => {
    const bodyElement = document.querySelector(".salepify-fg-advanced-body");
    bodyElement.innerHTML = '<div class="loader"></div>'
    let bodyHtml = "";
    const listRuleNeedToAddGift = [];
    const listRuleNeedToRemoveGift = [];

    let availableToClaim = 0;
    let needToReload = false
    let hasRuleMetCondition = false;
    for (let i = 0; i < window.tlAdvancedFreeGift.rules.length; i++) {
        const rule = window.tlAdvancedFreeGift.rules[i];
        const ruleId = rule.id;
        const [conditionState, claimedCount, canClaimCount, remain, remainSpecific] = window.tlAdvancedFreeGift.getRemain(rule);
        
        if(claimedCount < canClaimCount) {
            rule.auto_add_gift ? listRuleNeedToAddGift.push(ruleId) : null;
        }else if(claimedCount > canClaimCount){
            rule.auto_remove_gift ? listRuleNeedToRemoveGift.push({
                id: ruleId,
                removeTime: claimedCount - canClaimCount
            }): null;
        }
        
        // Store handle of parent and child product
        const uniqueProductHandle = new Set();
        
        // Store list parent id in order current product => required => rest product 
        const listChildDisplayIds = [];
        // ChildId map quantity required
        const childMapRequiredQty = {}
        rule.listChilds.map(child =>{
            listChildDisplayIds.push(child.shopify_id);
            if(!window.tlAdvancedFreeGift.shopifyIdMapData.get(child.product_id)){
                uniqueProductHandle.add(child.handle)
            }
            if(child.quantity){
                childMapRequiredQty[child.shopify_id] = child.quantity;
            }
        })

        // ParentId map quantity required
        const parentMapRequiredQty = {};

        const requireParents = []
        const highPriorityParents = [];
        const lowPriorityParents = [];
        const productIdKey = rule.apply_to_product === window.tlAdvancedFreeGift.APPLY_TO_PRODUCT.PRODUCT ? "shopify_id" : "product_id";

        if(
            (rule.apply_to_product === window.tlAdvancedFreeGift.APPLY_TO_PRODUCT.PRODUCT) ||
            (rule.apply_to_product === window.tlAdvancedFreeGift.APPLY_TO_PRODUCT.VARIANT)
        ){
            rule.listParents.map(parent =>{
                const productId = parent[productIdKey];
                if(!window.tlAdvancedFreeGift.shopifyIdMapData.get(productId)){
                    uniqueProductHandle.add(parent.handle);
                }

                if(productId == window.tlAdvancedFreeGift.currentProductId){
                    parent.quantity ? requireParents.unshift(parent.shopify_id) : highPriorityParents.unshift(parent.shopify_id);
                }else {
                    parent.quantity ? requireParents.push(parent.shopify_id) : lowPriorityParents.push(parent.shopify_id);
                }
                parentMapRequiredQty[parent.shopify_id] = parent.quantity;
            })
        }

        // Store list parent id in order current product => required => rest product 
        const listParentDisplayIds = [...requireParents, ...highPriorityParents, ...lowPriorityParents];
        await window.tlAdvancedFreeGift.updateProductData(Array.from(uniqueProductHandle));
        
        if(rule.show_free_gift_widget && window.tlAdvancedFreeGift.checkShowOnPage(rule.show_on_pages)){
            if(claimedCount < canClaimCount && !rule.auto_add_gift) {
                hasRuleMetCondition = true;
            }
            const totalGift = rule.gift_qty * window.tlAdvancedFreeGift.ruleIdMapCanClaimTime.get(ruleId);
            let offerTitleWhenConditionMeet = JSON.parse(rule.custom_text_display).offer_title_when_condition_meet;
            bodyHtml += `
                <div id="salepify-fg-advanced-main-section-${ruleId}"  
                    class="salepify-fg-advanced-main-section block--flex 
                    ${i == 0 ? " salepify-fg-advanced-main-section--view-more" : " salepify-fg-advanced-main-section--view-less"}
                    ${conditionState !== window.tlAdvancedFreeGift.CONDITION_STATE.NOT_MET ? " salepify-fg-advanced-main-section--allow-claim" : ""}
                    ${conditionState === window.tlAdvancedFreeGift.CONDITION_STATE.MET_AFFTER_CLAIM ? " salepify-fg-advanced-main-section--claimed" : ""}" 
                >
                    <div class="block--flex-inline flex--space-between">
                        <div class= "salepify-fg-advanced-main-section__offer-title text--bold">
                            ${conditionState === window.tlAdvancedFreeGift.CONDITION_STATE.NOT_MET ? 
                                window.tlAdvancedFreeGift.handleReplaceVariable(rule, window.tlAdvancedFreeGift.getOfferTitle(rule), remain, remainSpecific, totalGift) : 
                                offerTitleWhenConditionMeet
                            }
                        </div>
                        
                        <div 
                            class="salepify-fg-advanced-main-section__view-offer-btn btn--plain" 
                            onclick='window.tlAdvancedFreeGift.handleViewMore("${ruleId}")'
                        >
                            ${i == 0 ? "View less" : "View more"}
                        </div>
                    </div>
                    
                    <div class="salepify-fg-advanced-offer block--flex-inline">
                        ${window.tlAdvancedFreeGift.renderOffer(listParentDisplayIds)}
                    </div>

                    <div class="divider"></div>
                    
                    <div class="salepify-fg-advanced-customer-buy block--flex block--collapsible">
                        ${window.tlAdvancedFreeGift.renderCustomerBy(listParentDisplayIds, parentMapRequiredQty)}
                    </div>

                    <div class="salepify-fg-advanced-main-section__upsell-banner">
                        ${window.tlAdvancedFreeGift.handleReplaceVariable(
                            rule, 
                            window.tlAdvancedFreeGift.renderUpsellMsg(conditionState, rule.auto_add_gift), 
                            remain, 
                            remainSpecific, 
                            totalGift
                        )}
                    </div>

                    <div class="salepify-fg-advanced-gift-list block--flex block--collapsible">
                        ${window.tlAdvancedFreeGift.renderGifts(
                            listChildDisplayIds, 
                            childMapRequiredQty, 
                            conditionState,
                            rule
                        )}

                    </div>
                  
                    <div class="salepify-fg-advanced-footer block--flex-inline flex--space-between block--collapsible"
                        style="display: ${(conditionState !== window.tlAdvancedFreeGift.CONDITION_STATE.NOT_MET && !rule.auto_add_gift) ? "flex" : "none"}"
                    >
                        <div class="salepify-fg-advanced-footer__remain-gift-title">
                            ${window.tlAdvancedFreeGift.displaySettings.detail_section.selected_text.content} 
                            ${conditionState !== window.tlAdvancedFreeGift.CONDITION_STATE.MET_AFFTER_CLAIM ?
                                window.tlAdvancedFreeGift.getTotalSelectedGift(ruleId) : totalGift
                            }/${totalGift}
                        </div>

                        ${
                            conditionState === window.tlAdvancedFreeGift.CONDITION_STATE.MET_BEFORE_CLAIM ? 
                                `<div class="salepify-fg-advanced-footer__claim-btn btn--fake" onclick='window.tlAdvancedFreeGift.handleAddGiftAndReload(${ruleId})'>
                                    ${window.tlAdvancedFreeGift.displaySettings.claim_btn.not_claim}
                                </div>` :
                                `<div class="salepify-fg-advanced-footer__claim-btn salepify-fg-advanced-footer__claim-btn--claimed">
                                    ${window.tlAdvancedFreeGift.displaySettings.claim_btn.claimed}
                                </div> `
                        }
                    </div>
                    <div id="salepify-fg-advanced-error-${ruleId}">
                        <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512">
                            <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                        </svg>
                        <span class="salepify-fg-advanced-error__message"></span>
                    </div>
                </div>
            `;

            if(conditionState == window.tlAdvancedFreeGift.CONDITION_STATE.MET_BEFORE_CLAIM) availableToClaim ++;
        }else {
            if(rule.auto_add_gift) {
                needToReload = true;
                const listChildDisplayIds = [];
                const childMapRequiredQty = {}
                rule.listChilds.map(child =>{
                    listChildDisplayIds.push(child.shopify_id);
                    if(child.quantity){
                        childMapRequiredQty[child.shopify_id] = child.quantity;
                    }
                })
                if(rule.auto_add_type == window.tlAdvancedFreeGift.AUTO_ADD_TYPE.FIRST_AVAILABLE){
                    for (let i = 0; i < listChildDisplayIds.length; i++) {
                        const giftId = listChildDisplayIds[i];
                        const giftData = window.tlAdvancedFreeGift.shopifyIdMapData.get(giftId);
                        
                        if(giftData.available){
                            const selectedGift = {};
                            selectedGift[giftId] = rule.gift_qty;
                            window.tlAdvancedFreeGift.ruleIdMapSelectedGift.set(ruleId, selectedGift);
                            break;
                        }
                    }
                }else{
                    window.tlAdvancedFreeGift.ruleIdMapSelectedGift.set(ruleId, childMapRequiredQty);
                }
            }
        }
    }

    if(listRuleNeedToAddGift.length){
        if(window.tlAdvancedFreeGift.itemsInTempCart.size){
            listRuleNeedToAddGift.map((ruleId) => {
                window.tlAdvancedFreeGift.updateGiftsInTempCart(ruleId, true);
            })
        }else {
            const addCartReq = await window.tlAdvancedFreeGift.handleAddGift(listRuleNeedToAddGift);
            if(addCartReq.status === 200){
                window.tlAdvancedFreeGift.showIconPopUpMessage("You’ve received a gift. Please reload to view the changes.", availableToClaim)
                
                if(!window.TLCustomEventGiftsAdvanced){
                    window.location.reload();
                } else if (window.TLCustomEventGiftsAdvanced == 1) {
                    window.dispatchEvent(new CustomEvent("TLCustomEvent:FreeGiftsAdvanced-render-needToReload"));
                }
                
            }else {
                // Return error if there are not enough gift to add
                const addCartRes = await addCartReq.json();
                window.tlAdvancedFreeGift.showIconPopUpMessage(addCartRes.description, 1)
            }
        }
    }else {
        if(availableToClaim){
            window.tlAdvancedFreeGift.showIconPopUpMessage(window.tlAdvancedFreeGift.displaySettings.icon_popup.text, availableToClaim);
        }else {
            window.tlAdvancedFreeGift.iconPopupBadgeElement.style = "display: none";
        }
    }
    if(bodyHtml) {
        const popupIcon = document.querySelector(".salepify-fg-advanced-icon-popup__icon");
        
        popupIcon.style.display = window.tlAdvancedFreeGift.displaySettings.icon_popup.is_icon_displayed ? "block" : "none";
        window.tlAdvancedFreeGift.iconPopupElement.style.display = "flex";
        window.tlAdvancedFreeGift.iconPopupElement.style.backgroundImage = window.tlAdvancedFreeGift.displaySettings.icon_popup.is_icon_displayed ? "none" : `url(${window.tlAdvancedFreeGift.displaySettings.icon_popup.adv_free_gift_image.url})`;
  
        bodyElement.innerHTML = bodyHtml;

        if(hasRuleMetCondition){
            window.tlAdvancedFreeGift.openGiftModal();
        }
    }
    if(listRuleNeedToRemoveGift.length){
        await window.tlAdvancedFreeGift.handleRemoveGift(listRuleNeedToRemoveGift);
        if(!window.TLCustomEventGiftsAdvanced){
            window.location.reload();
        } else if (window.TLCustomEventGiftsAdvanced == 1) {
            window.dispatchEvent(new CustomEvent("TLCustomEvent:FreeGiftsAdvanced-render-needToRemoveGift"));
        }
    }
}
const newReRender = async () => {
    const listRuleNeedToAddGift = [];
    const listRuleNeedToRemoveGift = [];

    let availableToClaim = 0;
    let needToReload = false;
    let hasRuleMetCondition = false;
    for (let i = 0; i < window.tlAdvancedFreeGift.rules.length; i++) { 
        const rule = window.tlAdvancedFreeGift.rules[i];
        const ruleId = rule.id;
        const [conditionState, claimedCount, canClaimCount, remain, remainSpecific] = window.tlAdvancedFreeGift.getRemain(rule);
        
        if(claimedCount < canClaimCount) {
            rule.auto_add_gift ? listRuleNeedToAddGift.push(ruleId) : null;
        }else if(claimedCount > canClaimCount){
            rule.auto_remove_gift ? listRuleNeedToRemoveGift.push({
                id: ruleId,
                removeTime: claimedCount - canClaimCount
            }): null;
        }
        
        if(rule.show_free_gift_widget && window.tlAdvancedFreeGift.checkShowOnPage(rule.show_on_pages)){
            if(claimedCount < canClaimCount && !rule.auto_add_gift) {
                hasRuleMetCondition = true;
            }
            const totalGift = rule.gift_qty * window.tlAdvancedFreeGift.ruleIdMapCanClaimTime.get(ruleId);
            const mainSectionElement = document.querySelector(`#salepify-fg-advanced-main-section-${ruleId}`);

            // Offer title
            let offerTitleInnerHTML = JSON.parse(rule.custom_text_display).offer_title_when_condition_meet;

            if(conditionState === window.tlAdvancedFreeGift.CONDITION_STATE.NOT_MET){
                // Set state main section
                mainSectionElement.classList.remove("salepify-fg-advanced-main-section--allow-claim", "salepify-fg-advanced-main-section--claimed");
            
                offerTitleInnerHTML = window.tlAdvancedFreeGift.handleReplaceVariable(rule, window.tlAdvancedFreeGift.getOfferTitle(rule), remain, remainSpecific, totalGift);
            }else if(conditionState === window.tlAdvancedFreeGift.CONDITION_STATE.MET_BEFORE_CLAIM){
                // Set state main section
                mainSectionElement.classList.remove("salepify-fg-advanced-main-section--claimed");
                mainSectionElement.classList.add("salepify-fg-advanced-main-section--allow-claim")
            }else {
                // Set state main section
                mainSectionElement.classList.remove("salepify-fg-advanced-main-section--allow-claim");
                mainSectionElement.classList.add("salepify-fg-advanced-main-section--claimed")
            }

            // Set innerHTML of offer_title
            mainSectionElement.querySelector(".salepify-fg-advanced-main-section__offer-title").innerHTML = offerTitleInnerHTML;

            // Set innerHTML of upsell_msg
            mainSectionElement.querySelector(".salepify-fg-advanced-main-section__upsell-banner").innerHTML = window.tlAdvancedFreeGift.handleReplaceVariable(
                rule, 
                window.tlAdvancedFreeGift.renderUpsellMsg(conditionState, rule.auto_add_gift), 
                remain, 
                remainSpecific, 
                totalGift
            );

            // Footer elment
            const footerElment = mainSectionElement.querySelector(".salepify-fg-advanced-footer");
            if(!rule.auto_add_gift && conditionState !== window.tlAdvancedFreeGift.CONDITION_STATE.NOT_MET){
                //Set footer style
                footerElment.innerHTML = `
                    <div class="salepify-fg-advanced-footer__remain-gift-title">
                        ${window.tlAdvancedFreeGift.displaySettings.detail_section.selected_text.content} 
                        ${conditionState !== window.tlAdvancedFreeGift.CONDITION_STATE.MET_AFFTER_CLAIM ?
                            window.tlAdvancedFreeGift.getTotalSelectedGift(ruleId) : totalGift
                        }/${totalGift}
                    </div>
                        
                    ${
                        conditionState === window.tlAdvancedFreeGift.CONDITION_STATE.MET_BEFORE_CLAIM ? 
                            `<div class="salepify-fg-advanced-footer__claim-btn btn--fake" 
                                onclick='${window.tlAdvancedFreeGift.itemsInTempCart.size > 0 ? 
                                    `window.tlAdvancedFreeGift.handleAddGiftToTempCart(${ruleId})`  :
                                    `window.tlAdvancedFreeGift.handleAddGiftAndReload(${ruleId})` 
                                }'
                            >
                                ${window.tlAdvancedFreeGift.displaySettings.claim_btn.not_claim}
                            </div>` :
                            `<div class="salepify-fg-advanced-footer__claim-btn salepify-fg-advanced-footer__claim-btn--claimed">
                                ${window.tlAdvancedFreeGift.displaySettings.claim_btn.claimed}
                            </div> `
                    }
                `;
                footerElment.style.display = "flex";
            }else {
                footerElment.style.display = "none";
            }

            const listGiftElement = mainSectionElement.querySelectorAll(`div[id^="salepify-fg-advanced-gift-${ruleId}"]`);

            listGiftElement.forEach((element) => {
                const checkBoxElement = element.querySelector(".salepify-fg-advanced-checkbox");
                const imageElement = element.querySelector(".salepify-fg-advanced-gift-info__img");

                if(conditionState === window.tlAdvancedFreeGift.CONDITION_STATE.MET_BEFORE_CLAIM){
                    if(!rule.auto_add_gift){
                        //Set show checkbox
                        checkBoxElement.classList.remove("salepify-fg-advanced-checkbox--hide");
                        checkBoxElement.classList.add("salepify-fg-advanced-checkbox--show");
                    }

                    // Set image
                    imageElement.classList.remove("salepify-fg-advanced-gift-info__img--condition-not-met");
                    imageElement.querySelector("svg").style.display = "none";
                
                }else {
                    //Set hide checkbox
                    checkBoxElement.classList.remove("salepify-fg-advanced-checkbox--show");
                    checkBoxElement.classList.add("salepify-fg-advanced-checkbox--hide");
                    element.querySelector(".salepify-fg-advanced-gift-qty-selector").style.display = "none";

                    // Set image
                    if(conditionState === window.tlAdvancedFreeGift.CONDITION_STATE.NOT_MET){
                        imageElement.classList.add("salepify-fg-advanced-gift-info__img--condition-not-met");
                        imageElement.querySelector("svg").style.display = "block";
                        checkBoxElement.querySelector(".salepify-fg-advanced-checkbox__inp-cbx").checked = false;

                        if(!rule.auto_add_gift){
                            window.tlAdvancedFreeGift.ruleIdMapSelectedGift.set(ruleId, {}); 
                        }
                    }else {
                        imageElement.classList.remove("salepify-fg-advanced-gift-info__img--condition-not-met");
                        imageElement.querySelector("svg").style.display = "none";
                    }
                }
            })

            if(conditionState == window.tlAdvancedFreeGift.CONDITION_STATE.MET_BEFORE_CLAIM) availableToClaim ++;
        }else {
            if(rule.auto_add_gift) {
                needToReload = true;
                const listChildDisplayIds = [];
                const childMapRequiredQty = {}
                rule.listChilds.map(child =>{
                    listChildDisplayIds.push(child.shopify_id);
                    if(child.quantity){
                        childMapRequiredQty[child.shopify_id] = child.quantity;
                    }
                })
                if(rule.auto_add_type == window.tlAdvancedFreeGift.AUTO_ADD_TYPE.FIRST_AVAILABLE){
                    for (let i = 0; i < listChildDisplayIds.length; i++) {
                        const giftId = listChildDisplayIds[i];
                        const giftData = window.tlAdvancedFreeGift.shopifyIdMapData.get(giftId);
                        
                        if(giftData.available){
                            const selectedGift = {};
                            selectedGift[giftId] = rule.gift_qty;
                            window.tlAdvancedFreeGift.ruleIdMapSelectedGift.set(ruleId, selectedGift);
                            break;
                        }
                    }
                }else{
                    window.tlAdvancedFreeGift.ruleIdMapSelectedGift.set(ruleId, childMapRequiredQty);
                }
            }
        }
    }

    if(listRuleNeedToAddGift.length){
        if(window.tlAdvancedFreeGift.itemsInTempCart.size){
            listRuleNeedToAddGift.map((ruleId) => {
                window.tlAdvancedFreeGift.updateGiftsInTempCart(ruleId, true);
            })
        }else {
            const addCartReq = await window.tlAdvancedFreeGift.handleAddGift(listRuleNeedToAddGift);
            if(addCartReq.status === 200){
                window.tlAdvancedFreeGift.showIconPopUpMessage("You’ve received a gift. Please reload to view the changes.", availableToClaim);
                if(!window.TLCustomEventGiftsAdvanced){
                    window.location.reload();
                } else if (window.TLCustomEventGiftsAdvanced == 1) {
                    window.dispatchEvent(new CustomEvent("TLCustomEvent:FreeGiftsAdvanced-reRender-needToReload"));
                }
            }else {
                // Return error if there are not enough gift to add
                const addCartRes = await addCartReq.json();
                window.tlAdvancedFreeGift.showIconPopUpMessage(addCartRes.description, 1)
            }
        }
    }else {
        if(availableToClaim){
            window.tlAdvancedFreeGift.showIconPopUpMessage(window.tlAdvancedFreeGift.displaySettings.icon_popup.text, availableToClaim);
        }else {
            // window.tlAdvancedFreeGift.iconPopupBadgeElement.style = "display: none";
        }
    }

    window.tlAdvancedFreeGift.renderTempCart();
    if(hasRuleMetCondition){
        window.tlAdvancedFreeGift.openGiftModal();
    }
    if(listRuleNeedToRemoveGift.length){
        await window.tlAdvancedFreeGift.handleRemoveGift(listRuleNeedToRemoveGift);
        if(!window.TLCustomEventGiftsAdvanced){
            window.location.reload();
        } else if (window.TLCustomEventGiftsAdvanced == 1) {
            window.dispatchEvent(new CustomEvent("TLCustomEvent:FreeGiftsAdvanced-reRender-needToRemoveGift"));
        }
    }
}

function overwriteFGFunction(functionName, newFunctionValue) {
  window.tlAdvancedFreeGift[functionName] = newFunctionValue;
}

window.addEventListener("TLADVANCEDFG:change", async () => {
    console.log('cart change...')
    const originalUpdateCartData = window.tlAdvancedFreeGift.updateCartData;
    overwriteFGFunction('updateCartData', newUpdateCartData);
  
    const giftHandlesArray = getGiftHandlesArray();
    const cartData = await getCartData();
    
    const giftItemIndices = cartData.items.reduce((indices, item, index) => {
        if (giftHandlesArray.includes(item.handle) && item.properties['_salepify-advanced-fg'] && Array.isArray(item.discounts) && item.discounts.length === 0) {
            indices.push(index);
        }
        return indices;
    }, []);
    
    if (giftItemIndices.length > 0) {
        for (const index of giftItemIndices) {
            try {
                await fetch("/cart/change", {
                    method: 'POST',
                    headers: {
                        'Accept': "application/json",
                        'Content-Type': "application/json"
                    },
                    body: JSON.stringify({
                        line: index + 1,
                        quantity: 0
                    })
                });
            } catch (error) {
                console.error(`Failed to remove item at index ${index}:`, error);
            }
        }
        
        window.location.reload();
    } else {
      window.tlAdvancedFreeGift.updateCartData = originalUpdateCartData;
    }
});

// const updateReRender = () => {
//   console.log('here...')
//   if (window.tlAdvancedFreeGift) {
//     clearInterval(intervalId);

//     overwriteFGFunction('reRender', newReRender);
//   }
// }

// const intervalId = setInterval(updateReRender, 50);
// setTimeout(() => {
//   clearInterval(intervalId)
// }, 3000)

// document.addEventListener("DOMContentLoaded", () => {
//     const intervalId1 = setInterval(autoRemoveGiftOnCartPage, 50);

//     async function autoRemoveGiftOnCartPage() {
//         console.log('on cart page...');
//         overwriteFGFunction('render', newRender);
      
//         if (window.tlAdvancedFreeGift.rules.length) {
//             clearInterval(intervalId1);

//             const giftHandlesArray = getGiftHandlesArray();
//             const cartData = await getCartData();

//             let totalGiftProductCounter = 0;

//             const giftItemIndices = cartData.items.reduce((indices, item, index) => {
//                 if (giftHandlesArray.includes(item.handle)) {
//                   totalGiftProductCounter += 1;
//                 }
//                 if (giftHandlesArray.includes(item.handle) && item.properties['_salepify-advanced-fg'] && Array.isArray(item.discounts) && item.discounts.length === 0) {
//                     indices.push(index);
//                 }
//                 return indices;
//             }, []);

//             if (giftItemIndices.length === 1 && totalGiftProductCounter === 2) {
//                 console.log('special case')
//                 await fetch("/cart/change", {
//                     method: 'POST',
//                     headers: {
//                         'Accept': "application/json",
//                         'Content-Type': "application/json"
//                     },
//                     body: JSON.stringify({
//                         line: giftItemIndices[0] + 1,
//                         quantity: 1,
//                     })
//                 });
//                 window.location.reload();
//                 return;
//             }
                    
//             if (giftItemIndices.length > 0 && window.location.href === 'https://www.groceryowl.com.sg/cart') {
//                 for (const index of giftItemIndices) {
//                     try {
//                         await fetch("/cart/change", {
//                             method: 'POST',
//                             headers: {
//                                 'Accept': "application/json",
//                                 'Content-Type': "application/json"
//                             },
//                             body: JSON.stringify({
//                                 line: index + 1,
//                                 quantity: 0
//                             })
//                         });
//                     } catch (error) {
//                         console.error(`Failed to remove item at index ${index}:`, error);
//                     }
//                 }
                
//                 window.location.reload();
//             }
//         }
//     };

//     setTimeout(() => {
//         clearInterval(intervalId1);
//     }, 3000);
// });